import React from 'react'

import Checkbox from 'components/Form/Checkbox/Checkbox'

import styles from './Agreement.module.scss'

const Agreement = ({ value, onChange, text }) => (
    <div className={styles.agreement}>
        <Checkbox value={value} onUpdate={onChange} className={styles.checkbox} />
        <div className={styles.text}>{text}</div>
    </div>
)

export default Agreement
